import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Package, ShoppingBag, Mail, DollarSign, Sparkles, Eye, Palette } from "lucide-react";

function Stat({ icon: Icon, label, value }) {
  return (
    <div className="bg-[#111] border border-[#2A2A2A] p-5 sm:p-6">
      <div className="flex items-center justify-between mb-3">
        <span className="smallcaps">{label}</span>
        <Icon size={18} className="text-[#B87333]" />
      </div>
      <p className="font-display font-black text-3xl sm:text-4xl !text-white">{value}</p>
    </div>
  );
}

export default function AdminDashboard() {
  const [stats, setStats] = useState({ products: 0, orders: 0, paidRevenue: 0, customOrders: 0, workshops: 0, labViews: 0, labDesigns: 0 });

  useEffect(() => {
    Promise.all([
      api.get("/admin/products"),
      api.get("/admin/orders"),
      api.get("/admin/custom-orders"),
      api.get("/admin/workshop-interests"),
      api.get("/admin/resin-lab-stats"),
    ]).then(([p, o, c, w, r]) => {
      const paid = o.data.filter((x) => x.payment_status === "paid");
      setStats({
        products: p.data.length,
        orders: o.data.length,
        paidRevenue: paid.reduce((s, x) => s + (x.amount || 0), 0),
        customOrders: c.data.length,
        workshops: w.data.length,
        labViews: r.data.views || 0,
        labDesigns: r.data.designs || 0,
      });
    }).catch(() => {});
  }, []);

  return (
    <div data-testid="admin-dashboard">
      <h1 className="font-display text-3xl sm:text-4xl text-[#F5F5DC] mb-8 sm:mb-10 hidden lg:block">Dashboard</h1>
      <div className="grid grid-cols-2 lg:grid-cols-5 gap-3 sm:gap-6 mb-3 sm:mb-6">
        <Stat icon={Package} label="Products" value={stats.products} />
        <Stat icon={ShoppingBag} label="Orders" value={stats.orders} />
        <Stat icon={DollarSign} label="Revenue" value={`$${stats.paidRevenue.toFixed(0)}`} />
        <Stat icon={Mail} label="Commissions" value={stats.customOrders} />
        <Stat icon={Sparkles} label="Waitlist" value={stats.workshops} />
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-5 gap-3 sm:gap-6">
        <div data-testid="stat-lab-views"><Stat icon={Eye} label="Resin Lab Views" value={stats.labViews} /></div>
        <div data-testid="stat-lab-designs"><Stat icon={Palette} label="Lab Designs" value={stats.labDesigns} /></div>
      </div>
    </div>
  );
}
